import React from 'react'
import { push, navigateTo } from "gatsby-link"
import styled, { css } from 'styled-components'
import Link from 'gatsby-link'
import { VelocityComponent } from 'velocity-react'

if (typeof window !== 'undefined') {
	require('velocity-animate') 
	require('velocity-animate/velocity.ui') 
}

import close from '../../assets/icons/hamburger-close.svg'
import back from '../../assets/icons/arrow-left.svg'

import { media } from '../../styles/utils'
import { container, bgIcon, padding, hoverState } from '../../styles/global'
import { red } from '../../styles/colors';

class Contact extends React.Component {

	renderContactDetails = () => {
		const { data } = this.props;

		return data.acf.contact_details.map((contact, index) => {
			return (
				<Details>
					<Heading>{contact.subtitle}</Heading>
					<Email
						href={`mailto:${contact.email}`}
					>
						{contact.email}
					</Email>
				</Details>
			)
		})
	}

	resolveAnimation = () => {
		const { open, menuOpen } = this.props;

		if (!menuOpen) {
			return 'transition.expandOut'
		} 

		if (open) {
			return 'transition.slideRightIn'
		} else {
			return 'transition.slideRightOut'
		}
	}

	render() {
		const { open, menuOpen, toggleMenu, toggleContact, data } = this.props;

		return (
			<Wrapper
				open={open}
				menuOpen={menuOpen}
			>
				<Container>
					<Back
						onClick={toggleContact}
					/>

					<VelocityComponent
						runOnMount={true}
						animation={this.resolveAnimation()}
						duration={600}
						delay={open && menuOpen ? 350 : 0}
						easing={'easeOutCubic'}
					>
						<DetailsWrapper>
							{data && this.renderContactDetails()}
						</DetailsWrapper>
					</VelocityComponent>
					
					<Close
						onClick={toggleMenu}
					/>
				</Container>				
			</Wrapper>
		)
	}
}


const Wrapper = styled.div`
	background: black;
	height: 100vh;
	width: 100vw;

	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 12;

	pointer-events: none;
	opacity: 0;
	transition: all 350ms ease-out;

	display: flex;
	justify-content: center;

	will-change: opacity;
	transform: translateX(10%);

	${props => {
		if (props.open) return css`
			opacity: 1;
			pointer-events: all;
			transform: translateX(0)
		`
	}}
`

const Container = styled.div`
	${container}
	${padding}
	max-width: 1440px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 35px;

	${media.phone`
		padding: 15px 35px 35px;
	`}
`

const DetailsWrapper = styled.div`
	will-change: transform;
`

const Details = styled.div`
	display: flex;
	flex-direction: column;
	text-align: center;

	font-family: 'GT America Expanded Bold';
	font-size: 35px;
	color: white;

	&:not(:last-child) {
		margin-bottom: 100px;

		${media.phone`
			margin-bottom: 64px;
		`}
	}
`

const Heading = styled.div`
	font-size: 20px;
	text-transform: uppercase;
	margin-bottom: 32px;

	${media.phone`
		margin-bottom: 14px;
		font-size: 10px;
	`}
`

const Email = styled.a`
	font-size: 35px;
	text-transform: uppercase;
	color: white;
	${hoverState}

	${media.tablet`
		font-size: 24px;
	`}

	${media.phone`
		font-size: 14px;
	`}
`

// Back

const Back = styled.div`
	position: absolute;
	left: 52px;
	top: 60px;
	background-image: url(${back});
	height: 14px;
	width: 44px;
	${bgIcon}
	${hoverState}

	${media.phone`
		height: 10px;
		width: 32px;
		left: 15px;
		top: 37px;
	`}
`	

// Close

const Close = styled.div`
	position: absolute;
	right: 52px;
	top: 60px;
	background-image: url(${close});
	height: 20px;
	width: 20px;
	${bgIcon}
	${hoverState}

	${media.phone`
		position: absolute;
		bottom: 35px;
		top: auto;
		right: 50%;
		transform: translateX(50%);
	`}
`	

export default Contact




// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js